module.exports = __webpack_public_path__ + "static/media/instagram.02258151.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/instagram.png
 ** module id = 227
 ** module chunks = 0
 **/